export default {
    title: 'This trend is no longer active',
    link: 'To the successor of the trend'
}
